var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6h-5a1 1 0 00-1 1v16a1 1 0 001 1h5a1 1 0 001-1V7a1 1 0 00-1-1zm-5 17h5V7h-5v16zM15.5 0h-6a1 1 0 00-1 1v22a1 1 0 001 1h6a1 1 0 001-1V1a1 1 0 00-1-1zm-6 23h6V1h-6v22zM23.5 15h-5a1 1 0 00-1 1v7a1 1 0 001 1h5a1 1 0 001-1v-7a1 1 0 00-1-1zm-5 8h5v-7h-5v7z",
    fill: "#999"
  })));
}
SvgLeaderBoard.displayName = 'LeaderBoard';
export default SvgLeaderBoard;